var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('svg',{attrs:{"fill":"none","height":"14","viewBox":"0 0 14 14","width":"14","xmlns":"http://www.w3.org/2000/svg"}},[_c('path',{attrs:{"d":"M1 1L13 13","stroke":"#6B7280","stroke-linecap":"round","stroke-linejoin":"round","stroke-width":"1.5"}})])
}
var staticRenderFns = []

export { render, staticRenderFns }